import { useEffect, useState } from "react";

interface ScenePhoto {
  url: string;
  caption: string;
}

interface Scene {
  id: string;
  title: string;
  subtitle: string;
  desc: string;
  image: string;
  tag: string;
  highlight: string;
  photos: ScenePhoto[];
}

const scenes: Scene[] = [
  {
    id: "jimei",
    title: "集美学村",
    subtitle: "嘉庚精神",
    tag: "01",
    highlight: "爱国兴学，百年传承",
    desc: "陈嘉庚先生倾资兴学，集美学村融合闽南建筑与西洋风格，龙舟池畔书声琅琅，是爱国主义教育的精神圣地，也是厦门最具历史温度的文化地标。",
    image: "https://public.readdy.ai/ai/img_res/df655d696498853e2021aa18057074f4.jpg",
    photos: [
      {
        url: "https://readdy.ai/api/search-image?query=Jimei%20School%20Village%20Xiamen%20dragon%20boat%20lake%20panorama%2C%20beautiful%20reflection%20of%20red%20roof%20traditional%20buildings%20in%20calm%20water%2C%20golden%20afternoon%20light%2C%20lush%20green%20trees%20surrounding%2C%20peaceful%20serene%20atmosphere%2C%20wide%20angle%20photography%2C%20ultra%20detailed%2C%20vibrant%20colors&width=1200&height=800&seq=jimei_p1&orientation=landscape",
        caption: "龙舟池畔 · 倒影如画",
      },
      {
        url: "https://readdy.ai/api/search-image?query=Jimei%20Aoshan%20Hall%20Xiamen%2C%20grand%20traditional%20Chinese%20architecture%20building%20with%20ornate%20curved%20rooftop%2C%20red%20columns%2C%20stone%20steps%2C%20lush%20garden%2C%20warm%20sunlight%2C%20majestic%20and%20solemn%20atmosphere%2C%20detailed%20architectural%20photography&width=1200&height=800&seq=jimei_p2&orientation=landscape",
        caption: "鳌园石雕 · 嘉庚遗风",
      },
      {
        url: "https://readdy.ai/api/search-image?query=Jimei%20School%20Village%20Xiamen%20night%20view%2C%20illuminated%20traditional%20buildings%20reflecting%20in%20dragon%20boat%20lake%2C%20warm%20golden%20lights%2C%20romantic%20evening%20atmosphere%2C%20long%20exposure%20photography%2C%20ultra%20detailed%2C%20stunning%20scenery&width=1200&height=800&seq=jimei_p3&orientation=landscape",
        caption: "夜色学村 · 灯火辉煌",
      },
    ],
  },
  {
    id: "shapowei",
    title: "沙坡尾",
    subtitle: "文艺烟火",
    tag: "02",
    highlight: "渔港新生，创意聚落",
    desc: "沙坡尾是厦门最具文艺气息的老渔港，斑驳的渔船、涂鸦墙、独立咖啡馆与创意小店交织，古老与现代在此碰撞，是年轻人追逐灵感的精神栖息地。",
    image: "https://readdy.ai/api/search-image?query=Shapowei%20art%20district%20Xiamen%2C%20old%20fishing%20harbor%20with%20colorful%20boats%2C%20street%20art%20murals%2C%20vintage%20buildings%2C%20creative%20cafes%20and%20shops%2C%20warm%20evening%20golden%20hour%20light%2C%20bohemian%20artistic%20atmosphere%2C%20reflections%20in%20water%2C%20ultra%20detailed%20photography&width=1280&height=960&seq=culture002&orientation=portrait",
    photos: [
      {
        url: "https://readdy.ai/api/search-image?query=Shapowei%20Xiamen%20old%20harbor%20colorful%20fishing%20boats%20moored%20at%20dock%2C%20weathered%20wooden%20boats%20with%20peeling%20paint%2C%20reflections%20in%20calm%20water%2C%20vintage%20industrial%20buildings%20backdrop%2C%20warm%20golden%20hour%20light%2C%20artistic%20photography%2C%20ultra%20detailed&width=1200&height=800&seq=shapo_p1&orientation=landscape",
        caption: "老渔港 · 岁月斑驳",
      },
      {
        url: "https://readdy.ai/api/search-image?query=Shapowei%20Xiamen%20street%20art%20murals%20on%20old%20walls%2C%20colorful%20graffiti%20artwork%2C%20young%20people%20walking%2C%20creative%20indie%20cafes%20and%20boutique%20shops%2C%20bohemian%20urban%20atmosphere%2C%20warm%20afternoon%20light%2C%20vibrant%20street%20photography&width=1200&height=800&seq=shapo_p2&orientation=landscape",
        caption: "涂鸦墙 · 创意无界",
      },
      {
        url: "https://readdy.ai/api/search-image?query=Shapowei%20Xiamen%20rooftop%20bar%20cafe%20at%20sunset%2C%20people%20enjoying%20drinks%20overlooking%20the%20harbor%20and%20sea%2C%20warm%20orange%20sky%2C%20relaxed%20lifestyle%20atmosphere%2C%20modern%20renovation%20of%20old%20building%2C%20ultra%20detailed%20photography&width=1200&height=800&seq=shapo_p3&orientation=landscape",
        caption: "天台咖啡 · 海港余晖",
      },
    ],
  },
  {
    id: "qilou",
    title: "骑楼街",
    subtitle: "古韵新生",
    tag: "03",
    highlight: "百年商街，闽南风情",
    desc: "中山路骑楼街是厦门百年商业文化的缩影，连廊式建筑遮风挡雨，闽南风情与南洋气息交融。漫步其间，老字号与新潮店铺并肩而立，古韵与烟火气息扑面而来。",
    image: "https://readdy.ai/api/search-image?query=Xiamen%20Zhongshan%20Road%20arcade%20buildings%20qilou%20street%2C%20colonial%20style%20covered%20walkway%2C%20traditional%20Minnan%20architecture%2C%20bustling%20street%20scene%2C%20warm%20lantern%20lights%2C%20vintage%20shops%2C%20evening%20atmosphere%2C%20rich%20colors%2C%20cinematic%20photography%2C%20ultra%20detailed&width=1280&height=960&seq=culture003&orientation=portrait",
    photos: [
      {
        url: "https://readdy.ai/api/search-image?query=Xiamen%20Zhongshan%20Road%20qilou%20arcade%20street%20daytime%2C%20long%20perspective%20view%20of%20covered%20colonnade%20walkway%2C%20ornate%20colonial%20facade%20buildings%2C%20people%20shopping%2C%20warm%20sunlight%20filtering%20through%20arches%2C%20vibrant%20street%20life%2C%20ultra%20detailed%20wide%20angle&width=1200&height=800&seq=qilou_p1&orientation=landscape",
        caption: "骑楼长廊 · 百年风华",
      },
      {
        url: "https://readdy.ai/api/search-image?query=Xiamen%20old%20street%20traditional%20Minnan%20shop%20signs%2C%20red%20lanterns%20hanging%2C%20vintage%20storefronts%20with%20Chinese%20calligraphy%20signs%2C%20warm%20evening%20light%2C%20nostalgic%20atmosphere%2C%20street%20food%20vendors%2C%20ultra%20detailed%20photography&width=1200&height=800&seq=qilou_p2&orientation=landscape",
        caption: "老字号 · 闽南味道",
      },
      {
        url: "https://readdy.ai/api/search-image?query=Xiamen%20Zhongshan%20Road%20night%20market%2C%20illuminated%20arcade%20street%20with%20colorful%20lights%2C%20busy%20pedestrian%20street%2C%20red%20lanterns%20glowing%2C%20festive%20atmosphere%2C%20long%20exposure%20photography%2C%20vibrant%20nightlife%2C%20ultra%20detailed&width=1200&height=800&seq=qilou_p3&orientation=landscape",
        caption: "夜市灯火 · 烟火人间",
      },
    ],
  },
];

interface CulturePageProps {
  visible: boolean;
  onNext: () => void;
  onPrev: () => void;
}

interface PhotoModalProps {
  scene: Scene;
  onClose: () => void;
}

function PhotoModal({ scene, onClose }: PhotoModalProps) {
  const [activePhoto, setActivePhoto] = useState(0);
  const [imgLoaded, setImgLoaded] = useState(false);

  const prev = () => setActivePhoto((p) => (p - 1 + scene.photos.length) % scene.photos.length);
  const next = () => setActivePhoto((p) => (p + 1) % scene.photos.length);

  useEffect(() => {
    setImgLoaded(false);
  }, [activePhoto]);

  // Close on Escape
  useEffect(() => {
    const handler = (e: KeyboardEvent) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-4xl mx-4 rounded-2xl overflow-hidden bg-gray-950"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-5 md:px-6 py-4 border-b border-white/10">
          <div className="flex items-center gap-3">
            <span className="text-amber-400 text-xs font-mono tracking-widest">{scene.tag}</span>
            <div className="w-px h-4 bg-white/20" />
            <h3
              className="text-white text-base md:text-lg font-semibold"
              style={{ fontFamily: "'Noto Serif SC', serif" }}
            >
              {scene.title}
            </h3>
            <span className="hidden sm:inline text-white/40 text-xs tracking-wider">· {scene.subtitle}</span>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-white text-base" />
          </button>
        </div>

        {/* Main Image */}
        <div className="relative w-full bg-black" style={{ height: "clamp(220px, 50vw, 480px)" }}>
          {/* Image */}
          <img
            key={activePhoto}
            src={scene.photos[activePhoto].url}
            alt={scene.photos[activePhoto].caption}
            className={`w-full h-full object-cover object-center transition-opacity duration-500 ${imgLoaded ? "opacity-100" : "opacity-0"}`}
            onLoad={() => setImgLoaded(true)}
          />
          {/* Loading placeholder */}
          {!imgLoaded && (
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-8 h-8 border-2 border-amber-400/40 border-t-amber-400 rounded-full animate-spin" />
            </div>
          )}

          {/* Gradient overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent pointer-events-none" />

          {/* Caption */}
          <div className="absolute bottom-4 left-5 md:left-6">
            <p className="text-white text-sm md:text-base font-medium" style={{ fontFamily: "'Noto Serif SC', serif" }}>
              {scene.photos[activePhoto].caption}
            </p>
          </div>

          {/* Photo counter */}
          <div className="absolute top-4 right-5 md:right-6">
            <span className="bg-black/50 backdrop-blur-sm text-white/80 text-xs px-2.5 py-1 rounded-full">
              {activePhoto + 1} / {scene.photos.length}
            </span>
          </div>

          {/* Prev / Next arrows */}
          <button
            onClick={prev}
            className="absolute left-3 md:left-4 top-1/2 -translate-y-1/2 w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-black/40 backdrop-blur-sm border border-white/20 text-white hover:bg-black/60 transition-all cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-xl" />
          </button>
          <button
            onClick={next}
            className="absolute right-3 md:right-4 top-1/2 -translate-y-1/2 w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-black/40 backdrop-blur-sm border border-white/20 text-white hover:bg-black/60 transition-all cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-xl" />
          </button>
        </div>

        {/* Thumbnail strip + info */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 px-5 md:px-6 py-4">
          {/* Thumbnails */}
          <div className="flex items-center gap-2 flex-shrink-0">
            {scene.photos.map((photo, i) => (
              <button
                key={i}
                onClick={() => setActivePhoto(i)}
                className={`relative overflow-hidden rounded-lg transition-all duration-300 cursor-pointer flex-shrink-0 ${
                  i === activePhoto ? "ring-2 ring-amber-400 opacity-100" : "opacity-50 hover:opacity-80"
                }`}
                style={{ width: "64px", height: "44px" }}
              >
                <img src={photo.url} alt={photo.caption} className="w-full h-full object-cover object-center" />
              </button>
            ))}
          </div>

          {/* Divider */}
          <div className="hidden sm:block w-px h-10 bg-white/10 flex-shrink-0" />

          {/* Scene info */}
          <div className="flex-1 min-w-0">
            <p className="text-amber-400 text-xs tracking-widest mb-0.5">{scene.highlight}</p>
            <p className="text-white/60 text-xs leading-relaxed line-clamp-2">{scene.desc}</p>
          </div>
        </div>

        {/* Dot indicators */}
        <div className="flex items-center justify-center gap-2 pb-4">
          {scene.photos.map((_, i) => (
            <button
              key={i}
              onClick={() => setActivePhoto(i)}
              className={`rounded-full transition-all duration-300 cursor-pointer ${
                i === activePhoto ? "w-6 h-1.5 bg-amber-400" : "w-1.5 h-1.5 bg-white/30 hover:bg-white/50"
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default function CulturePage({ visible, onNext, onPrev }: CulturePageProps) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [entered, setEntered] = useState(false);
  const [transitioning, setTransitioning] = useState(false);
  const [modalScene, setModalScene] = useState<Scene | null>(null);

  useEffect(() => {
    if (visible) {
      const t = setTimeout(() => setEntered(true), 100);
      return () => clearTimeout(t);
    } else {
      setEntered(false);
      setModalScene(null);
    }
  }, [visible]);

  const goTo = (index: number) => {
    if (transitioning || index === activeIndex) return;
    setTransitioning(true);
    setTimeout(() => {
      setActiveIndex(index);
      setTransitioning(false);
    }, 300);
  };

  const handlePrevScene = () => {
    if (activeIndex > 0) goTo(activeIndex - 1);
    else onPrev();
  };

  const handleNextScene = () => {
    if (activeIndex < scenes.length - 1) goTo(activeIndex + 1);
    else onNext();
  };

  const active = scenes[activeIndex];

  return (
    <div className="relative w-full h-screen overflow-hidden bg-stone-50">
      {/* Top Nav */}
      <nav className="absolute top-0 left-0 right-0 z-30 flex items-center justify-between px-5 md:px-8 py-4 md:py-5">
        <img
          src="https://public.readdy.ai/ai/img_res/87bc98b4-e616-459b-81b0-cc0db54579b8.png"
          alt="Logo"
          className="h-8 md:h-9 w-auto object-contain"
          style={{ filter: "brightness(0) invert(0)" }}
        />
        <div className="hidden md:flex items-center gap-6">
          {["山海", "人文", "美食", "活力"].map((item, i) => (
            <span
              key={item}
              className={`text-xs tracking-widest cursor-pointer transition-colors whitespace-nowrap ${i === 1 ? "text-amber-700 font-medium" : "text-gray-500 hover:text-gray-800"}`}
            >
              {item}
            </span>
          ))}
        </div>
      </nav>

      {/* Layout */}
      <div className="flex flex-col md:flex-row h-full">

        {/* Image area */}
        <div className="relative flex-1 h-[55vh] md:h-full">
          <div className={`absolute inset-0 transition-opacity duration-500 ${transitioning ? "opacity-0" : "opacity-100"}`}>
            <img
              src={active.image}
              alt={active.title}
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/30 to-transparent" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
          </div>

          {/* Scene thumbnails */}
          <div className="absolute bottom-4 left-4 md:bottom-16 md:left-8 z-20 flex gap-2 md:gap-3">
            {scenes.map((scene, i) => (
              <button
                key={scene.id}
                onClick={() => goTo(i)}
                className={`relative overflow-hidden rounded-lg md:rounded-xl transition-all duration-300 cursor-pointer ${
                  i === activeIndex
                    ? "w-16 h-12 md:w-24 md:h-16 ring-2 ring-white"
                    : "w-10 h-12 md:w-14 md:h-16 opacity-60 hover:opacity-80"
                }`}
              >
                <img src={scene.image} alt={scene.title} className="w-full h-full object-cover object-top" />
                {i === activeIndex && (
                  <div className="absolute inset-0 bg-black/20 flex items-end p-1">
                    <span className="text-white text-xs font-medium">{scene.title}</span>
                  </div>
                )}
              </button>
            ))}
          </div>

          {/* Content overlay */}
          <div
            className={`absolute left-5 md:left-12 top-16 md:top-1/2 md:-translate-y-1/2 z-20 max-w-xs transition-all duration-700 ${
              entered && !transitioning ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-6"
            }`}
          >
            <div className="inline-flex items-center gap-2 mb-2 md:mb-4">
              <span className="text-white/50 text-xs font-mono">{active.tag}</span>
              <div className="w-6 md:w-8 h-px bg-white/40" />
              <span className="text-white/70 text-xs tracking-widest">03 / CULTURE</span>
            </div>
            <h2
              className="text-3xl md:text-6xl font-light text-white mb-1 md:mb-2 leading-tight"
              style={{ fontFamily: "'Noto Serif SC', serif" }}
            >
              人文鹭岛
            </h2>
            <p className="text-white/70 text-xs md:text-sm tracking-wider mb-3 md:mb-5">
              嘉庚风骨，文艺烟火，古韵新生
            </p>

            {/* View photos button */}
            <button
              onClick={() => setModalScene(active)}
              className="group flex items-center gap-2 bg-white/15 backdrop-blur-sm border border-white/30 text-white text-xs px-4 py-2 rounded-full hover:bg-white/25 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-image-2-line text-amber-300" />
              <span>查看实景照片</span>
              <i className="ri-arrow-right-line text-white/60 group-hover:translate-x-0.5 transition-transform duration-200" />
            </button>
          </div>
        </div>

        {/* Detail Panel */}
        <div
          className={`relative w-full md:w-80 lg:w-96 bg-white flex flex-col justify-center px-5 md:px-8 py-5 md:py-12 flex-shrink-0 transition-all duration-700 ${
            entered ? "opacity-100 translate-y-0 md:translate-x-0" : "opacity-0 translate-y-4 md:translate-y-0 md:translate-x-10"
          }`}
          style={{ minHeight: "45vh", maxHeight: "45vh" }}
        >
          {/* Decorative line */}
          <div className="hidden md:block absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-amber-200 via-amber-400 to-amber-200" />
          <div className="md:hidden absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-amber-200 via-amber-400 to-amber-200" />

          <div className={`transition-all duration-400 ${transitioning ? "opacity-0 translate-y-4" : "opacity-100 translate-y-0"}`}>
            <span className="text-amber-600 text-xs tracking-[0.25em] font-medium uppercase mb-1 md:mb-2 block">
              {active.subtitle}
            </span>
            <h3
              className="text-2xl md:text-3xl font-semibold text-gray-900 mb-1 md:mb-3"
              style={{ fontFamily: "'Noto Serif SC', serif" }}
            >
              {active.title}
            </h3>
            {/* Highlight tag */}
            <div className="inline-flex items-center gap-1.5 bg-amber-50 border border-amber-200 rounded-full px-3 py-1 mb-2 md:mb-4">
              <i className="ri-map-pin-line text-amber-500 text-xs" />
              <span className="text-amber-700 text-xs font-medium">{active.highlight}</span>
            </div>
            <div className="w-8 h-0.5 bg-amber-400 mb-2 md:mb-4" />
            <p className="text-gray-600 text-xs md:text-sm leading-relaxed line-clamp-3 md:line-clamp-none">{active.desc}</p>

            {/* Photo preview strip */}
            <div
              className="flex items-center gap-1.5 mt-3 md:mt-5 cursor-pointer group"
              onClick={() => setModalScene(active)}
            >
              {active.photos.map((photo, i) => (
                <div
                  key={i}
                  className="relative overflow-hidden rounded-lg flex-shrink-0 transition-all duration-300 group-hover:opacity-90"
                  style={{ width: "52px", height: "36px" }}
                >
                  <img src={photo.url} alt={photo.caption} className="w-full h-full object-cover object-center" />
                  {i === active.photos.length - 1 && (
                    <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
                      <i className="ri-zoom-in-line text-white text-xs" />
                    </div>
                  )}
                </div>
              ))}
              <div className="ml-1 flex items-center gap-1 text-amber-600 text-xs font-medium group-hover:text-amber-700 transition-colors">
                <span className="whitespace-nowrap">查看全部</span>
                <i className="ri-arrow-right-s-line" />
              </div>
            </div>

            {/* Scene switcher dots */}
            <div className="flex items-center gap-2 md:gap-3 mt-3 md:mt-6">
              {scenes.map((_, i) => (
                <button
                  key={i}
                  onClick={() => goTo(i)}
                  className={`transition-all duration-300 rounded-full cursor-pointer ${
                    i === activeIndex ? "w-6 md:w-8 h-2 bg-amber-500" : "w-2 h-2 bg-gray-200 hover:bg-gray-300"
                  }`}
                />
              ))}
            </div>
          </div>

          {/* Navigation */}
          <div className="absolute bottom-4 md:bottom-8 right-4 md:right-8 flex gap-2">
            <button
              onClick={handlePrevScene}
              className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-full border border-gray-200 text-gray-500 hover:border-amber-400 hover:text-amber-600 transition-all cursor-pointer"
            >
              <i className="ri-arrow-left-s-line" />
            </button>
            <button
              onClick={handleNextScene}
              className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-full bg-amber-500 text-white hover:bg-amber-600 transition-all cursor-pointer"
            >
              <i className="ri-arrow-right-s-line" />
            </button>
          </div>
        </div>
      </div>

      {/* Page indicator */}
      <div className="absolute bottom-3 md:bottom-6 left-1/2 -translate-x-1/2 z-20 flex items-center gap-2">
        {[0, 1, 2].map((i) => (
          <div key={i} className={`rounded-full transition-all duration-300 ${i === 2 ? "w-6 h-1.5 bg-amber-500" : "w-1.5 h-1.5 bg-gray-300"}`} />
        ))}
      </div>

      {/* Photo Modal */}
      {modalScene && (
        <PhotoModal scene={modalScene} onClose={() => setModalScene(null)} />
      )}
    </div>
  );
}
